import { jsx as _jsx } from "react/jsx-runtime";
const Placeholder = ({ attributes, children }) => {
    return (_jsx("span", Object.assign({}, attributes, { style: Object.assign(Object.assign({}, attributes.style), { top: 0 }) }, { children: children })));
};
export default Placeholder;
